import { schema } from "normalizr";

export const checklistenSchema = new schema.Entity("checklisten");
